import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'lib-data-model-customization-header',
  templateUrl: './data-model-customization-header.component.html',
  styleUrls: ['./data-model-customization-header.component.scss'],
  standalone: false,
})
export class DataModelCustomizationHeaderComponent implements OnInit {
  @Input() classes: any;
  @Output() selectedClass = new EventEmitter<number>();
  @Output() addNewModal = new EventEmitter<void>();
  currentClass: any;
  ngOnInit(): void {
    this.currentClass = this.classes[0];
  }

  selectClass(index: number) {
    this.currentClass = this.classes[index];
    this.selectedClass.emit(index);
  }

  addNew(){
    this.addNewModal.emit();
  }
}
